/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EmployeePostClassStudentViewModelPaginatedResponse } from "../types/EmployeePostClassStudentViewModelPaginatedResponse.ts";
import { employeePostClassStudentViewModelSchema } from "./employeePostClassStudentViewModelSchema.ts";

export const employeePostClassStudentViewModelPaginatedResponseSchema =
  z.object({
    data: z
      .array(z.lazy(() => employeePostClassStudentViewModelSchema))
      .nullish(),
    currentPage: z.optional(z.number().int()),
    totalPages: z.optional(z.number().int()),
    totalCount: z.optional(z.number().int()),
  }) as unknown as ToZod<EmployeePostClassStudentViewModelPaginatedResponse>;
